function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material Imports
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import { useTheme } from "@mui/material/styles";

// Limitless imports
import { withi18n } from "../../hocs/i18n";
import DialogueBody from "../../dialogue-body/DialogueBody";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import TimePosted from "../../time-posted/TimePosted";
import { formatRating } from "@limitless/common/utils/date-utils/DateUtils";
import { USER_TYPE_GENAI } from "../../../../portal/utils/Constants";
const useStyles = makeStyles(() => ({
  dialogueContainer: {
    width: "100%",
    alignItems: props => props.isRtl ? "flex-end" : "flex-start",
    // Align to the right in RTL, left in LTR
    textAlign: props => props.isRtl ? "right" : "left" // Set text alignment based on direction
  },
  marginText: {
    marginTop: 16
  }
}));
const ExpertDialogue = ({
  t,
  isReported,
  message,
  dialogue,
  ...rest
}) => {
  const isRtl = document.documentElement.getAttribute("dir") === "rtl"; // Check if the document is in RTL

  const classes = useStyles({
    isRtl
  });
  const {
    author,
    body,
    created,
    userId,
    userType
  } = dialogue;
  const expertInfo = message.expertAuthors[userId];
  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, _extends({
    author: author,
    expertInfo: expertInfo
  }, rest), expertClasses => /*#__PURE__*/React.createElement("div", {
    className: classes.dialogueContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: `${expertClasses.listItem} ${expertClasses.expertBackground}`
  }, /*#__PURE__*/React.createElement(DialogueBody, {
    body: body,
    textStyling: isReported ? expertClasses.blurText : expertClasses.expertText,
    linkify: !isReported
  }), author && /*#__PURE__*/React.createElement(Typography, {
    className: `${expertClasses.expertText} ${classes.marginText}`,
    variant: "caption"
  }, userType === USER_TYPE_GENAI ? t("Posted by {0} (AI Expert)", author) : t("Posted by {0}", author)), expertInfo && /*#__PURE__*/React.createElement(Typography, {
    className: expertClasses.expertText,
    variant: "caption"
  }, t("{0} answers | {1} rating", expertInfo.answerCount, formatRating(expertInfo.rating)))), created && /*#__PURE__*/React.createElement("div", {
    className: expertClasses.responseTime
  }, /*#__PURE__*/React.createElement(TimePosted, {
    time: created
  }))));
};
ExpertDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  isReported: PropTypes.bool,
  message: PropTypes.object.isRequired
};
ExpertDialogue.defaultProps = {
  isReported: false
};
export default withi18n(ExpertDialogue);